import { VendorEquipmentTypes } from 'types';

/** Human-readable labels for the AVL equipment types (no label map exists in `types`). */
export const VendorEquipmentTypeLabels: Record<VendorEquipmentTypes, string> = {
  [VendorEquipmentTypes.inverter]: 'Inverter',
  [VendorEquipmentTypes.panel]: 'Panel',
  [VendorEquipmentTypes.mounting]: 'Mounting',
  [VendorEquipmentTypes.storage]: 'Storage',
  [VendorEquipmentTypes.heatPump]: 'Heat Pump',
  [VendorEquipmentTypes.airHandler]: 'Air Handler',
  [VendorEquipmentTypes.heatStrip]: 'Heat Strip',
  [VendorEquipmentTypes.thermostat]: 'Thermostat',
  [VendorEquipmentTypes.furnace]: 'Furnace',
  [VendorEquipmentTypes.waterHeater]: 'Water Heater',
};
